export interface IEcology {
  /** Расстояние в виде форматированной строки **/
  distance?: string | null;
  /** Изображения **/
  images: IEcologyImage[];
  /** Название **/
  title: string;
  /** Тип транспорта **/
  transportType?: ETransportType | null;
}

export enum ETransportType {
  /** На транспорте **/
  Transport = 'transport',
  /** Пешком **/
  Walk = 'walk',
}

export interface IEcologyImage {
  /** Урл изображения **/
  url: string;
}
